// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumbs_breadcrumb__vxShG","breadcrumb__item":"Breadcrumbs_breadcrumb__item__O5oon"};